function initFadeOutImage() {
  const fadeOutImage = document.querySelector( '.fade-out-image' );


  if (fadeOutImage && window.innerWidth > 850) {
    window.addEventListener( 'scroll', (event) => {
      fadeOutImage.style.opacity = 1 - window.scrollY / (fadeOutImage.offsetHeight / 1.25);
    } );

    window.addEventListener( 'load', (event) => {
      fadeOutImage.style.opacity = 1 - window.scrollY / (fadeOutImage.offsetHeight / 1.25);
    } );
  }
}

export default {
  init() {
    initFadeOutImage();
  },
};